import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import parse from 'html-react-parser'

type Props = {
  html: string
  className?: string
  sx?: SxProps<Theme>
  fontSize?: string
}

export function QuillHtmlParser({ html, className, sx, fontSize }: Props) {
  const combinedClassName = className ? `ql-editor ${className}` : 'ql-editor'
  // const safeHtml = DOMPurify.sanitize(html) // <- use if needed
  return (
    <Box
      id="index__components-rich-description__box__l14"
      className={combinedClassName}
      sx={{
        padding: 0,
        height: 'auto',
        overflowY: 'visible',
        overflowX: 'visible',
        whiteSpace: 'normal',
        fontSize: fontSize || '14px',
        lineHeight: 1.4,

        '& ul, & ol': {
          listStyle: 'revert',
          paddingLeft: '40px',
          // marginTop: '16px',
          // marginBottom: '16px',
        },
        '& li': {
          marginTop: '0px',
          marginBottom: '0px',
        },
        // '& p': {
        //   marginTop: '8px',
        //   marginBottom: '8px',
        // },

        ...sx,
      }}
    >
      {parse(html)}
    </Box>
  )
}
